<template>
  <div>
    <!-- 回访录音 -->
    <el-dialog
      v-model="open"
      width="500"
      :show-close="false"
      :close-on-click-modal="false"
      draggable
      :modal="false"
      destroy-on-close
      @open="openDialog"
      @close="closeDialog"
    >
      <template #header="{ close, titleId, titleClass }">
        <div class="dialog-header">
          <h3 :id="titleId" :class="titleClass">回访录音</h3>
          <el-button class="close-btn" @click="close">
            <el-icon :size="16"><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <div class="dialog-body">
        <div class="dialog-body-audio">
          <div ref="visualizerRef" style="width: 100%; height: 100px"></div>
          <audio ref="audioRef" crossOrigin="anonymous" controls autoplay preload="auto" style="width: 100%">
            <source :src="audioUrl" type="audio/mpeg" />
            <source :src="audioUrl" type="audio/flac" />
            <source :src="audioUrl" type="audio/aiff" />
            <source :src="audioUrl" type="audio/m4a" />
            您的浏览器不支持 audio 元素。
          </audio>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
const props = defineProps({
    url:{
        type: String,
        default:'',
        required:true
    }
});

const emits = defineEmits(['refresh']);
const { proxy } = getCurrentInstance();
const open = defineModel('visible', { type: Boolean, required: true, default: false });
const audioUrl = ref('');
const visualizerRef = useTemplateRef('visualizerRef');
const audioRef = useTemplateRef('audioRef');
const timeout = ref(null); //节流器

function openDialog() {
  audioUrl.value = props.url;
  if (audioRef.value.paused) {
    audioRef.value
      .play()
      .then(() => {
        visualize();
      })
      .catch(() => {});
  }

}

//音频可视化
function visualize() {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const source = audioContext.createMediaElementSource(audioRef.value);
  const analyser = audioContext.createAnalyser();
  analyser.fftSize = 256;

  source.connect(analyser);
  analyser.connect(audioContext.destination);

  const bufferLength = analyser.frequencyBinCount;
  const dataArray = new Uint8Array(bufferLength);

  const canvas = document.createElement('canvas');
  const canvasCtx = canvas.getContext('2d');
  canvas.width = getComputedStyle(visualizerRef.value).getPropertyValue('width').replace('px', '');
  canvas.height = 100;
  visualizerRef.value.appendChild(canvas);
  function draw() {
    requestAnimationFrame(draw);
    analyser.getByteFrequencyData(dataArray);
    canvasCtx.fillStyle = 'rgba(0, 0, 0, 0.1)';
    canvasCtx.fillRect(0, 0, canvas.width, canvas.height);
    const barWidth = (canvas.width / bufferLength) * 2.5;
    let x = 0;

    for (let i = 0; i < bufferLength; i++) {
      const barHeight = dataArray[i] * 0.5;
      const hue = (i / bufferLength) * 360;
      canvasCtx.fillStyle = `hsl(${hue}, 100%, 50%)`;
      canvasCtx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);

      x += barWidth + 1;
    }
  }

  draw();
}

function closeDialog() {
  if (timeout.value) clearInterval(timeout.value);
  audioUrl.value = '';
  audioRef.value.pause();
  audioRef.value.currentTime = 0;
  emits('refresh');
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  .el-dialog__header {
    padding: 0 20px;
    margin: 0;
    border-bottom: 1px solid #6e6e6e;

    .dialog-header {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-dialog__title {
        flex: 1;
        width: 100%;
        margin: 0;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
      }
      .close-btn {
        width: 25px;
        height: 25px;
        padding: 0;
        margin-inline-end: auto;
        border-radius: 50%;
      }
    }
  }
  .dialog-body {
    .dialog-body-text {
      display: inline-flex;
      flex-wrap: wrap;
      .text__inline {
        line-height: 24px;
        &:not(:last-child) {
          margin-right: 50px;
        }
        span + span {
          margin-left: 5px;
        }
      }
    }
    .dialog-body-audio {
      width: 100%;
    }
  }

  .el-dialog__footer {
    width: 100%;
  }
}
</style>
